import React from 'react';
import { SignIn } from '@clerk/clerk-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBranding } from 'modules/App/hooks/useBranding';
import { appendRedirectUrl, getSafeRedirectUrl } from 'modules/Auth/redirectUrl';
import { supplierAwareAfterAuthUrl } from 'modules/FreeSupplier/routes';
import { buildClerkAppearance } from 'modules/Common/config/clerkAppearance';
import { darkSurfaceAccent } from 'modules/Common/utils/brandColor';
import AuthShell from 'modules/Auth/components/AuthShell';

const SignInPage = () => {
  const { t } = useTranslation();
  const brand = useBranding();
  // Footer sits on AuthShell's dark backdrop — near-black brand primaries
  // swap to their dark-surface accent, same rule as the shell's own accents.
  const accent = darkSurfaceAccent(brand.key);
  const redirectUrl = getSafeRedirectUrl();
  const afterSignInUrl = supplierAwareAfterAuthUrl(redirectUrl);
  const signUpUrl = appendRedirectUrl('/sign-up', redirectUrl);

  return (
    <AuthShell
      footer={
        <p className="mt-3 text-center text-sm text-white/60 lg:hidden">
          {t('auth.newHerePrompt', 'New here?')}{' '}
          <Link
            to={signUpUrl}
            className="font-medium text-primaryColor hover:underline"
            style={{ color: accent }}
          >
            {t('auth.createAccountLink', 'Create an account')}
          </Link>
        </p>
      }
    >
      <SignIn
        withSignUp={true}
        afterSignInUrl={afterSignInUrl}
        afterSignUpUrl={afterSignInUrl}
        appearance={buildClerkAppearance(brand)}
      />
    </AuthShell>
  );
};

export default SignInPage;
